/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowchannelfacebook3Inputs */

const en_aiflowchannelfacebook3 = /** @type {(inputs: Aiflowchannelfacebook3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facebook`)
};

const de_aiflowchannelfacebook3 = /** @type {(inputs: Aiflowchannelfacebook3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facebook`)
};

/**
* | output |
* | --- |
* | "Facebook" |
*
* @param {Aiflowchannelfacebook3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowchannelfacebook3 = /** @type {((inputs?: Aiflowchannelfacebook3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowchannelfacebook3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowchannelfacebook3(inputs)
	return de_aiflowchannelfacebook3(inputs)
});
export { aiflowchannelfacebook3 as "aiFlowChannelFacebook" }